import { Component, Input, OnInit } from '@angular/core';
import { ResourceListItemDTO } from '../../../dtos/resources.dto';
import {
  checkIfDistrictApproved,
  checkIfE2lRecommended,
} from '../../../services/resources/resource.helpers';

@Component({
  selector: 'app-resource-list-item',
  templateUrl: './resource-list-item.component.html',
  styleUrls: ['./resource-list-item.component.scss'],
  standalone: false,
})
export class ResourceListItemComponent implements OnInit {
  @Input() resourceListItem: ResourceListItemDTO;

  @Input() userDistrictId: number | null;

  path: string;

  ngOnInit(): void {
    if (this.resourceListItem.slug) {
      this.path = this.resourceListItem.slug;
    } else if (this.resourceListItem.url) {
      const splitUrl = this.resourceListItem.url.split('/');
      this.path = splitUrl[splitUrl.length - 1];
    } else {
      this.path = '';
    }

    if (this.resourceListItem.endorsements && this.userDistrictId) {
      this.resourceListItem.e2lRecommended = checkIfE2lRecommended(
        this.resourceListItem.endorsements
      );
      this.resourceListItem.districtApproved = checkIfDistrictApproved(
        this.resourceListItem.endorsements,
        this.userDistrictId
      );
    }
  }
}
